import React from 'react';
//Add
import NoimgMen from '../img/user/noimg_men.png';
import NoimgWomen from '../img/user/noimg_women.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Blank from '../img/blank/blank-1x1.gif';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
    }
  }

	render() {
    let lazyLoad = true;
    let background = '#EFEFEF';

    if (this.props.lazyLoad === false) {
      lazyLoad = false;
    }

    if (this.props.background) {
      background = this.props.background;
    }


    if (this.props.mainImg.quit === true) {
      return (
        <div
          style={{
            display: 'inline-block',
            position:'relative',
            overflow:'hidden',
            width: this.props.width,
            maxWidth: ((this.props.maxWidth) ? this.props.maxWidth : '320px'),
            minWidth: ((this.props.minWidth) ? this.props.minWidth : '20px'),
            height: this.props.height,
            borderRadius: this.props.radius,
            verticalAlign: 'bottom',
          }}
        >
          <img
            src={ (this.props.mainImg.sex === 'men'? NoimgMen: NoimgWomen) }
            style={{
              background: background,
              width: '100%',
              height: 'auto',
            }}
            alt=''
          />
          <img
            src={Blank}
            style={{
              position: 'absolute',
              left:0,
              top:0,
              width:'100%',
              height:'100%',
              background:'rgba(0, 0, 0, 0.5)',
            }}
            alt=''
          />
          <div style={{
            position: 'absolute',
            left:0,
            top:0,
            width:'100%',
            height:'100%',
            display:'flex',
            flexDirection:'row',
            justifyContent:'center',
            alignItems:'center',
            color:'#FFF',
            fontSize: ((this.props.fontSize) ? this.props.fontSize : '1em'),
          }}>
            <div>退会</div>
          </div>
        </div>
      )
    }
    else if (this.props.mainImg.stop === true) {
      return (
        <div
          style={{
            display: 'inline-block',
            position:'relative',
            overflow:'hidden',
            width: this.props.width,
            maxWidth: ((this.props.maxWidth) ? this.props.maxWidth : '320px'),
            minWidth: ((this.props.minWidth) ? this.props.minWidth : '20px'),
            height: this.props.height,
            borderRadius: this.props.radius,
            verticalAlign: 'bottom',
          }}
        >
          <img
            src={ (this.props.mainImg.sex === 'men'? NoimgMen: NoimgWomen) }
            style={{
              background: background,
              width: '100%',
              height: 'auto',
            }}
            alt=''
          />
          <img
            src={Blank}
            style={{
              position:'absolute',
              left:0,
              top:0,
              width:'100%',
              height:'100%',
              background:'rgba(0, 0, 0, 0.5)',
            }}
            alt=''
          />
          <div style={{
            position:'absolute',
            left:0,
            top:0,
            width:'100%',
            height:'100%',
            display:'flex',
            flexDirection:'row',
            justifyContent:'center',
            alignItems:'center',
            color:'#FFF',
            fontSize: ((this.props.fontSize) ? this.props.fontSize : '1em'),
          }}>
            <div>停止</div>
          </div>
        </div>
      )
    }
    else if (this.props.mainImg.src) {

        return (
          <div
            style={{
              display: 'inline-block',
              position:'relative',
              overflow:'hidden',
              maxWidth: ((this.props.maxWidth) ? this.props.maxWidth : '320px'),
              minWidth: ((this.props.minWidth) ? this.props.minWidth : '20px'),
              width: this.props.width,
              height: this.props.height,
              borderRadius: this.props.radius,
              verticalAlign: 'bottom',
            }}
          >
            {
              (lazyLoad === true) ? (
                <LazyLoadImage
                  src={ this.props.mainImg.src }
                  style={{
                    background: background,
                    width: '100%',
                    height: 'auto',
                  }}
                  placeholder={<img src={Blank} style={{width:'100%', height:'auto',}} alt='' />}
                  alt=''
                />
              ): (
                <img
                  src={ this.props.mainImg.src }
                  style={{
                    background: background,
                    width: '100%',
                    height: 'auto',
                  }}
                  alt=''
                />
              )
            }

            <img
              src={Blank}
              style={{
                position:'absolute',
                left:0,
                top:0,
                width:'100%',
                height:'100%',
              }}
              alt=''
            />
          </div>
        )
    }
    else {
      return (
        <div
          style={{
            display: 'inline-block',
            position:'relative',
            overflow:'hidden',
            width: this.props.width,
            maxWidth: ((this.props.maxWidth) ? this.props.maxWidth : '320px'),
            minWidth: ((this.props.minWidth) ? this.props.minWidth : '20px'),
            height: this.props.height,
            borderRadius: this.props.radius,
            verticalAlign: 'bottom',
          }}
        >
          <img
            src={ (this.props.mainImg.sex === 'men'? NoimgMen: NoimgWomen) }
            style={{
              background: background,
              width: '100%',
              height: 'auto',
            }}
            alt=''
          />
        </div>
      )
    }

	}
}

export default Comp;
